import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const USERNAME = 'username'
export const PASSWORD = 'password'
export const FULL_NAME = 'full name'
export const CONFIRM_PASSWORD = 'confirm password'
export const CREATE_USER = 'create user'
export const VALIDATION_PASSWORD = 'validation password'
export const VALIDATION_EMAIL = 'validation email'
export const USER_REGISTERED = 'user registered'

export default {
  [PORTUGUESE]: {
    [USERNAME]: 'Nome do usuário',
    [PASSWORD]: 'Senha',
    [FULL_NAME]: 'Nome Completo',
    [CONFIRM_PASSWORD]: 'Confirme a Senha',
    [CREATE_USER]: 'Criar Usuário',
    [VALIDATION_PASSWORD]: 'A Senha e a Confirmação de Senha não são iguais.',
    [VALIDATION_EMAIL]: 'Você digitou um endereço de e-mail inválido.',
    [USER_REGISTERED]: 'Usuário cadastrado com sucesso',
  },

  [ENGLISH]: {
    [USERNAME]: 'Username',
    [PASSWORD]: 'Password',
    [FULL_NAME]: 'Full Name',
    [CONFIRM_PASSWORD]: 'Confirm Password',
    [CREATE_USER]: 'Create User',
    [VALIDATION_PASSWORD]: 'The Password and the Confirm Password are not the same.',
    [VALIDATION_EMAIL]: 'You have entered an invalid email address.',
    [USER_REGISTERED]: 'User registered successfully',
  },

  [SPANISH]: {
    [USERNAME]: 'Nombre de usuario',
    [PASSWORD]: 'La Contraseña',
    [FULL_NAME]: 'Nombre Completo',
    [CONFIRM_PASSWORD]: 'Confirmar Contraseña',
    [CREATE_USER]: 'Crear Usuario',
    [VALIDATION_PASSWORD]:
      'La contraseña y la contraseña de confirmación no son lo mismo.',
    [VALIDATION_EMAIL]: 'Has introducido una dirección de correo electrónico no válida.',
    [USER_REGISTERED]: 'Usuario registrado exitosamente',
  },
}
